export const reactSelectDark = {
  control: (base, state) => ({
    ...base,
    backgroundColor: '#393b3f',
    borderColor: state.isFocused ? '#4e8cff' : '#3b3b4f',
    // minHeight: '32px',
    height: '42px',
    // fontSize: '0.85rem',
    color: '#f1f1f1',
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#5a5a72'
    }
  }),

  menu: (base) => ({
    ...base,
    backgroundColor: '#282a2c',
    color: '#f1f1f1',
    borderRadius: 6,
    marginTop: 4,
    zIndex: 9999
  }),

  option: (base, { isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isSelected ? 'rgba(4, 169, 245, 0.2)' : isFocused ? 'rgba(78, 140, 255, 0.09)' : '#282a2c',
    color: '#f1f1f1',
    cursor: 'pointer',
    fontSize: '0.85rem'
  }),

  singleValue: (base) => ({
    ...base,
    color: '#f1f1f1'
  }),

  placeholder: (base) => ({
    ...base,
    color: '#9ca3af' // muted light
  }),

  valueContainer: (base) => ({
    ...base,
    height: '32px',
    padding: '0 6px'
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: '32px'
  })
};
